<template>
	<section class="top-logo section is-hidden-touch"></section>

	<top-nav />

	<tag-strip />

	<slot />

	<footer-bar />
</template>
<script lang="ts" setup>
import FooterBar from "../components/FooterBar.vue";
import TopNav from "../components/TopNav.vue";
import TagStrip from "../components/TagStrip.vue";
</script>
<style>
.top-logo {
	background-image: url("/img/logo.webp");
	background-repeat: no-repeat;
	background-position: center;
	padding: 5rem !important;
}

.tag:not(:first-child) {
	margin-left: 0.3em;
}
</style>
